module.exports = __webpack_public_path__ + "img/50.8c45bee0.svg";